import { ReportTreeItemResponse, ReportTreeResponseItem, ReportFilterItem } from '@/types/service-response'
import _ from 'lodash'
import moment from 'moment'

export class ReportMenuTreeItem {
  private constructor (
    readonly groupId: number,
    readonly id: number,
    readonly reportGroupName: string,
    readonly name: string,
    readonly children: { reportId: number, id: number, reportName: string, name: string, reportLayout: string, filters: Array<ReportFilterItem>, }[]
  ) {}

  public static createMenuFromResponse (data: ReportTreeItemResponse): Array<ReportMenuTreeItem> {
    const result: Array<ReportMenuTreeItem> = []

    data.forEach((item: ReportTreeResponseItem) => {
      if (!result.some((resultItem: ReportMenuTreeItem) => resultItem.reportGroupName === item.ReportGroupName)) {
        const reportGroupName = item.ReportGroupName
        const id = item.GroupId
        const children = data
          .filter((i: ReportTreeResponseItem) => i.ReportGroupName === reportGroupName)
          .map((i: ReportTreeResponseItem) => {
            let filters = _.cloneDeep(i.Filters)
            filters.forEach((item: ReportFilterItem) => {
              item.IsRequired = true
            })
            if (i.ReportLayout === 'PEPI_MA_Kontakt') {
              filters.forEach((item: ReportFilterItem) => {
                if (item.Name === 'Abteilung') {
                  item.Items.unshift({
                    FilterItemId: 0,
                    FilterItemValue: 'Alle'
                  })
                }
              })
            }
            if (i.ReportLayout === 'PEPI_MA_PlgGrp') {
              filters.forEach((item: ReportFilterItem) => {
                if (item.Name === 'Abteilung') {
                  item.Items.unshift({
                    FilterItemId: 0,
                    FilterItemValue: 'Alle'
                  })
                }
              })
            }
            if (i.ReportLayout === 'PEPI_Kompetenzen') {
              filters.forEach((item: ReportFilterItem) => {
                if (item.Name === 'Filiale') {
                  item.Items.unshift({
                    FilterItemId: '%',
                    FilterItemValue: 'Alle'
                  })
                }
                if (item.Name === 'Abteilung') {
                  item.Items.unshift({
                    FilterItemId: '%',
                    FilterItemValue: 'Alle'
                  })
                }
              })
            }
            if (i.ReportLayout === 'PEPI_Security') {
              filters.forEach((item: ReportFilterItem) => {
                if (item.Name === 'Filter') {
                  item.Items.unshift({
                    FilterItemId: '%',
                    FilterItemValue: 'Alle Mitarbeiter'
                  })
                }
              })
            }
            if (i.ReportLayout === 'PEPI_AB_VB') {
              filters.forEach((item: ReportFilterItem) => {
                if (item.Name === 'Grund') {
                  item.Items.unshift({
                    FilterItemId: 999,
                    FilterItemValue: 'Alle'
                  })
                }
              })
            }
            if (i.ReportLayout === 'PEPI_AB_JahrDet') {
              filters.forEach((item: ReportFilterItem) => {
                if (item.Name === 'Grund') {
                  item.Items.unshift({
                    FilterItemId: 999,
                    FilterItemValue: 'Alle'
                  })
                }
              })
            }
            if (i.ReportLayout === 'PEPI_AB_JahrTotTage') {
              filters.forEach((item: ReportFilterItem) => {
                if (item.Name === 'Grund') {
                  item.Items.unshift({
                    FilterItemId: 999,
                    FilterItemValue: 'Alle'
                  })
                }
              })
            }
            if (i.ReportLayout === 'PEPI_AB_Jahr') {
              filters.forEach((item: ReportFilterItem) => {
                if (item.Name === 'Grund') {
                  item.Items.unshift({
                    FilterItemId: 999,
                    FilterItemValue: 'Alle'
                  })
                }
              })
            }
            if (i.ReportLayout === 'PEPI_AB_MAJahrDet') {
              filters.forEach((item: ReportFilterItem) => {
                if (item.Name === 'Grund') {
                  item.Items.unshift({
                    FilterItemId: 999,
                    FilterItemValue: 'Alle'
                  })
                }
              })
            }
            if (i.ReportLayout === 'PFA_ArbeitsnachweisNEU') {
              filters.forEach((item: ReportFilterItem) => {
                if (item.Name === 'Jahr') {
                  let currentYear = moment(new Date()).format('YYYY')
                  for (let i = parseInt(currentYear) - 2; i <= parseInt(currentYear); i++) {
                    item.Items.push({
                        FilterItemId: 1,
                        FilterItemValue: i.toString()
                    })
                  }
                }
              })
            }

            return {
              reportId: i.ReportId,
              reportName: i.ReportName,
              id: i.ReportId,
              name: i.ReportName,
              reportLayout: i.ReportLayout,
              filters: filters
            }
          })
        result.push(new ReportMenuTreeItem(item.GroupId, id, item.ReportGroupName, item.ReportGroupName, children))
      }
    })
    return result
  }

}